module.exports = __webpack_public_path__ + "files/a64e134208e4b556aa9adfd286aa46ab.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/katex/dist/fonts/KaTeX_Caligraphic-Regular.woff
 ** module id = 1041
 ** module chunks = 0
 **/